import { YhBox } from "@/erp_subpackage/components/YhBox";
import useGlobalModel from "@/erp_subpackage/model/globalModel";
import { importPropsConfig } from "@/erp_subpackage/utils/importFile";
import { MyContext } from "@/store/myContext";
import { Button, Input, Menu, message, Modal, Spin, Upload } from "antd";
import moment from 'moment';
import React, { useContext } from "react";
import { useTranslation } from 'react-i18next';
import { useCustomerModel } from "../customerModel";
import { DataTable } from "./DataTable";

export const DataBox = () => {
    const { t } = useTranslation();
    const { dataSource, selectedRowKeys, searchParam, exportCustomer, sync, downloadTpl, uploading, setUploading, loadData } = useCustomerModel()
    const { state, dispatch, detailsPage, tabs } = useContext(MyContext)
    const { user: { shopId, shopName } } = useGlobalModel()
    //新增 查看 编辑
    const goPageNav = (mode) => {
        let tabName = {
            add: t(`base.view.DataBox.客户新增`),
            edit: t(`base.view.DataBox.客户编辑`),
            look: t(`base.view.DataBox.客户查看`),
        }
        let modeKey = "baseCustomer/" + mode

        //动态传入要删除的nav key
        function handleDispatch(obj = {}) {
            dispatch({
                ...obj,
                type: "changeTabs",
                name: tabName[mode],
                activeMenu: modeKey,
                content: detailsPage.BaseCustomerDetails({
                    dispatch,
                    modeKey,
                    mode,
                    rowId: selectedRowKeys[0],
                }),
            })
        }

        if (mode === "edit") {
            const findNav = state.panes.find((item) => item.key === modeKey)
            if (findNav) {
                Modal.confirm({
                    title: `${t(`base.view.DataBox.温馨提醒`)}！`,
                    content: t(`base.view.DataBox.您还有客户详情未保存，是否跳转`),
                    okText: t(`base.view.DataBox.跳转未保存页`),
                    cancelText: t(`base.view.DataBox.打开新页签`),
                    onOk: () => {
                        handleDispatch()
                    },
                    //打开新页签重新生成
                    onCancel: () => {
                        handleDispatch({ deleteKey: modeKey })
                    },
                })
                return
            }
            handleDispatch()
        } else if (mode === "add") {
            handleDispatch()
        } else if (mode === "look") {
            handleDispatch({ deleteKey: modeKey })
        }
    }

    // 下属车辆
    const goVehicle = () => {
        if (selectedRowKeys.length !== 1) {
            message.warning(t(`base.view.DataBox.请选择单条数据进行车辆`))
            return;
        }
        const modeKey = "baseVehicle"
        dispatch({
            change: true,
            type: "changeTabs",
            name: t(`base.view.DataBox.车辆管理`),
            activeMenu: modeKey,
            targetKey: modeKey,
            content: tabs.baseVehicle({
                customerName: dataSource.find(el => el.id === selectedRowKeys[0])?.name
            }),
        })
    }
    const uploadCallback = (params) => {
        setUploading({ spinning: false })
        params && loadData()
    }

    const setTitle = () => {
        let name = "";
        Modal.confirm({
            title: t(`base.view.DataBox.同步客户`),
            content: <>
                <Input placeholder= {t(`base.view.DataBox.请输入要同步的客户名称`)} onChange={(e) => { name = e.target.value }} />
            </>,
            okText: t(`base.view.DataBox.确定`),
            cancelText: t(`base.view.DataBox.取消`),
            onOk: () => {
                return new Promise((resolve, reject) => {
                    if (name) {
                        resolve(name);
                    } else {
                        message.warning(t(`base.view.DataBox.请输入要同步的客户名称`));
                        reject(t(`base.view.DataBox.请输入要同步的客户名称`));
                    }
                }).then(res => {
                    sync({ name: res });
                });
            },
            onCancel: () => { }
        })
    };

    const menu = (
        <Menu>
            <Menu.Item onClick={() => sync()} key="all">
                <span style={{ color: "#00f" }}> {t(`base.view.DataBox.同步所有`)}</span>
            </Menu.Item>
            <Menu.Item onClick={setTitle} key="customer">
                <span style={{ color: "#00f" }}> {t(`base.view.DataBox.同步客户`)}</span>
            </Menu.Item>
        </Menu>
    )

    const action = (
        <>
            <Button
                className="btn-item"
                shape="round"
                onClick={() => {
                    goPageNav("add")
                }}
            > {t(`base.view.DataBox.新增`)}</Button>
            <Button
                className="btn-item"
                shape="round"
                onClick={() => {
                    if (selectedRowKeys.length !== 1) {
                        message.warning(`${t(`base.view.DataBox.请选择单条数据进行编辑，点击鼠标右键可一键选中哦`)}！`)
                        return
                    }
                    goPageNav("edit")
                }}
                disabled={searchParam.shopId}
            > {t(`base.view.DataBox.编辑`)}</Button>
            <Button
                className="btn-item"
                shape="round"
                onClick={() => {
                    if (selectedRowKeys.length !== 1) {
                        message.warning(`${t(`base.view.DataBox.请选择单条数据进行查看，点击鼠标右键可一键选中哦`)}！`)
                        return
                    }
                    goPageNav("look")
                }}
            > {t(`base.view.DataBox.查看`)}</Button>
            <Upload showUploadList={false}  {...importPropsConfig(`/ci-storage/base/customer/import`, uploadCallback, { shopId, shopName }, () => setUploading({ spinning: true, tip:`${ t(`base.view.DataBox.加速上传中`)}...` }))}>
                <Button className="btn-item" type="link" shape="round" disabled={searchParam.shopId}> {t(`base.view.DataBox.导入`)}</Button>
            </Upload>
            <Button
                className="btn-item"
                shape="round"
                onClick={() => exportCustomer()}
            >
                 {t(`base.view.DataBox.导出`)}
            </Button>
            <Button
                className="btn-item"
                shape="round"
                onClick={() => downloadTpl()}
                disabled={searchParam.shopId}
            >
                 {t(`base.view.DataBox.下载模板`)}
            </Button>
            <Button
                className="btn-item"
                shape="round"
                onClick={() => {
                    goVehicle()
                }}
            >
                 {t(`base.view.DataBox.下属车辆`)}
            </Button>
            <Button
                className="btn-item"
                shape="round"
                onClick={() => sync({ createTime: moment(new Date()).format("YYYY-MM-DD") })}
            >
                {t(`base.view.DataBox.增量同步`)}
            </Button>
        </>
    )
    return (
        <Spin {...uploading}>
            <YhBox title={t(`base.view.DataBox.客户列表`)} action={action}>
                <DataTable />
            </YhBox>
        </Spin>
    )
}
